var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontSizeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17357 12.604C9.05166 12.604 8.93791 12.5265 8.89649 12.4045L5.62516 2.58879L2.35266 12.4051C2.30191 12.558 2.13799 12.6396 1.98399 12.5895C1.83116 12.5381 1.74891 12.373 1.79966 12.2202L5.34807 1.57437C5.42741 1.33637 5.82232 1.33637 5.90107 1.57437L9.44949 12.2202C9.50024 12.373 9.41799 12.5381 9.26516 12.5895C9.23482 12.6 9.20332 12.604 9.17357 12.604Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81673 9.61446H3.15007C2.98907 9.61446 2.8584 9.48321 2.8584 9.32279C2.8584 9.16238 2.98907 9.03113 3.15007 9.03113H7.81673C7.97715 9.03113 8.1084 9.16238 8.1084 9.32279C8.1084 9.48321 7.97773 9.61446 7.81673 9.61446Z",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1499 3.44045C10.0957 3.44045 10.0414 3.42587 9.99359 3.39553L8.21909 2.27787C8.08375 2.19212 8.04175 2.01187 8.12867 1.87653C8.21384 1.74237 8.39525 1.69862 8.53 1.78612L10.1488 2.80578L11.7669 1.78612C11.904 1.70095 12.0831 1.74237 12.1688 1.87653C12.254 2.01187 12.2138 2.19212 12.0778 2.27787L10.3033 3.39553C10.2578 3.42587 10.2042 3.44045 10.1499 3.44045Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSizeSmall);
export default __webpack_public_path__ + "static/media/font-size-small.1de03c4cf62ed5ce125fbc70ebbf3c04.svg";
export { ForwardRef as ReactComponent };